const BYTES_PER_KILOBYTE = 1000;

const BYTES_PER_MEGABYTE = 1_000_000;

const BYTES_PER_GIGABYTE = 1_000_000_000;

const BYTES_PER_KIBIBYTE = 1024;

const BYTES_PER_MEBIBYTE = 1_048_576;

const BYTES_PER_GIBIBYTE = 1_073_741_824;

export class MemSize {
  private readonly bytes: number;

  private constructor(bytes: number) {
    if (!Number.isFinite(bytes) || bytes < 0) {
      throw new RangeError("MemSize must be finite and nonnegative");
    }

    this.bytes = bytes;
  }

  public static GiB(gibibytes: number): MemSize {
    return new MemSize(gibibytes * BYTES_PER_GIBIBYTE);
  }

  public static KiB(kibibytes: number): MemSize {
    return new MemSize(kibibytes * BYTES_PER_KIBIBYTE);
  }

  public static MiB(mebibytes: number): MemSize {
    return new MemSize(mebibytes * BYTES_PER_MEBIBYTE);
  }

  public static bytes(bytes: number): MemSize {
    return new MemSize(bytes);
  }

  public static gigabytes(gigabytes: number): MemSize {
    return new MemSize(gigabytes * BYTES_PER_GIGABYTE);
  }

  public static kilobytes(kilobytes: number): MemSize {
    return new MemSize(kilobytes * BYTES_PER_KILOBYTE);
  }

  public static megabytes(megabytes: number): MemSize {
    return new MemSize(megabytes * BYTES_PER_MEGABYTE);
  }

  public toBytes(): number {
    return this.bytes;
  }

  public toGiB(): number {
    return this.bytes / BYTES_PER_GIBIBYTE;
  }

  public toGigabytes(): number {
    return this.bytes / BYTES_PER_GIGABYTE;
  }

  public toKiB(): number {
    return this.bytes / BYTES_PER_KIBIBYTE;
  }

  public toKilobytes(): number {
    return this.bytes / BYTES_PER_KILOBYTE;
  }

  public toMegabytes(): number {
    return this.bytes / BYTES_PER_MEGABYTE;
  }

  public toMiB(): number {
    return this.bytes / BYTES_PER_MEBIBYTE;
  }
}
